import { TableRow, TableCell, createTheme, TextField, Select, MenuItem } from "@mui/material";

function AdmPartidas(infos) {
  const theme = createTheme({
    components: {
      MuiTableCell: {
        styleOverrides: {
          root: {
            fontSize: '0.8rem',
            color: 'white',
            padding: '0',
            border: '0'
          }
        },
      },
    },
  });

  const selectSx = {
    color: 'white',
    fontSize: '0.75rem',
    width: 72,
    '& .MuiOutlinedInput-notchedOutline': { borderColor: 'white' },
    '& .MuiSvgIcon-root': { color: 'white' },
    '& .MuiSelect-select': { padding: '4px 24px 4px 6px' },
  };

  return (
    <>
      {infos.partidas.map((partidas) => (
        <TableRow key={partidas.ID}>

          {infos.times
            ? <TableCell sx={{ maxWidth: 80, padding: 0 }} align="center" theme={theme}>
                <Select
                  size="small"
                  value={infos.timesEditados?.[partidas.ID]?.TIME1 ?? partidas.TIME1}
                  onChange={(e) => infos.funcaoTime1(partidas.ID, e.target.value)}
                  renderValue={(v) => v}
                  sx={selectSx}
                >
                  <MenuItem value="TBD">TBD — A definir</MenuItem>
                  {infos.times.map(t => (
                    <MenuItem key={t.ID} value={t.ID}>{t.ID} — {t.NOME}</MenuItem>
                  ))}
                </Select>
              </TableCell>
            : <TableCell sx={{ maxWidth: 74 }} align="center" theme={theme}>{partidas.TIME1}</TableCell>
          }

          <TableCell sx={{ maxWidth: 50, border: 1, borderColor: 'white' }} align="center" theme={theme}>
            <TextField
              defaultValue={partidas.RESULTADO1}
              sx={{ input: { color: 'white', textAlign: 'center' } }}
              required type="number" id={partidas.ID} time='1'
              onChange={infos.funcao1}
            />
          </TableCell>

          <TableCell sx={{ maxWidth: 21 }} align="center" theme={theme}>X</TableCell>

          <TableCell sx={{ maxWidth: 50, border: 1, borderColor: 'white' }} align="center" theme={theme}>
            <TextField
              defaultValue={partidas.RESULTADO2}
              sx={{ input: { color: 'white', textAlign: 'center' } }}
              required type="number" id={partidas.ID}
              onChange={infos.funcao2}
            />
          </TableCell>

          {infos.times
            ? <TableCell sx={{ maxWidth: 80, padding: 0 }} align="center" theme={theme}>
                <Select
                  size="small"
                  value={infos.timesEditados?.[partidas.ID]?.TIME2 ?? partidas.TIME2}
                  onChange={(e) => infos.funcaoTime2(partidas.ID, e.target.value)}
                  renderValue={(v) => v}
                  sx={selectSx}
                >
                  <MenuItem value="TBD">TBD — A definir</MenuItem>
                  {infos.times.map(t => (
                    <MenuItem key={t.ID} value={t.ID}>{t.ID} — {t.NOME}</MenuItem>
                  ))}
                </Select>
              </TableCell>
            : <TableCell sx={{ maxWidth: 74 }} align="center" theme={theme}>{partidas.TIME2}</TableCell>
          }

          {infos.times && (
            <TableCell align="center" theme={theme} sx={{ fontSize: '0.7rem', color: '#aaa', paddingLeft: '8px' }}>
              {partidas.DATA}
            </TableCell>
          )}

        </TableRow>
      ))}
    </>
  );
}

export default AdmPartidas;
